import $ from 'jquery';
import GetApiMasterDataClass from './parts/airplane/GetApiMasterDataClass';
import ParentPageBaseClass from './parts/common/ParentPageBaseClass';
import PreloaderClass from './parts/common/PreloaderClass';
import RecommendTicketClass from './parts/airplane/RecommendTicketClass';

/**
 * 総合トップ T-01 PC・SP共通クラス
 */
class IH01PageClass extends ParentPageBaseClass {
  constructor() {
    super();
    this.name = 'IH01PageClass';

    this.parts = {
      recommendTicket: new RecommendTicketClass(),
    };

    this.isApiCall = false;
  }

  onCreate() {
    super.onCreate();
    this.preloader = new PreloaderClass($('#preloader'));

    // 航空券側のAPIを取得
    GetApiMasterDataClass.getMasterTicketData(LtikeCommon.API.AIRPLANE.TOP, () => {
      this.isApiCall = true;
      this.parts.recommendTicket.onSetData();
      this.onComplete();
    });
  }

  onAllImageLoadComplete() {
    this.isAllLoadComplete = true;
    this.onComplete();
  }

  onComplete() {
    if (!this.isAllLoadComplete || !this.isApiCall) { return; }
    this.preloader.onHide();
    this.onImageLoadEnd();
  }

}
export const pageCl = new IH01PageClass();
